import { FC, useCallback } from 'react';
import pageTitleClass from '../../assets/scss/SubscriptionDetail/PageTitle.module.scss';

export const PageTitle: FC<{ clickBackBtnFunc: () => void }> = ({ clickBackBtnFunc }) => {
  const clickBackBtnHandler = useCallback(() => {
    clickBackBtnFunc();
  }, [clickBackBtnFunc]);

  return (
    <div className={pageTitleClass.pageTop}>
      <a
        className={pageTitleClass.backBtn}
        onClick={clickBackBtnHandler}
      >
        マイアカウントトップに戻る
      </a>
    </div>
  );
};
